import JoditEditor from 'jodit-react';
import React, { useRef } from 'react';

const QuillSecond = (props) => {
    const { secondContent, setSecondContent } = props;
    const editorRef = useRef(null);

    const config = {
        readonly: false,
        placeholder: 'Start typing...',
        toolbarAdaptive: false,
        removeButtons: [
            'print', 'font', 'fontsize', 'brush', 'image', 'file', 'video', 'about',
            'className', 'paint', 'lineHeight', 'classSpan', 'spellcheck', 'copyformat',
            'ai-assistant', 'ai-commands',
        ],
        toolbarSticky: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: true,
        defaultActionOnCut: 'insert_as_html',
        defaultActionOnPaste: 'insert_as_html',
        defaultActionOnPasteFromWord: 'insert_as_html',
        usePopupForSpecialCharacters: false,
        events: {
            beforePaste: () => {
                // alert('Copy successful');
            },
        },
    };

    const handleEditorChange = (newContent) => {
        if (editorRef.current) {
            if (newContent !== editorRef.current.value) {
                setSecondContent(newContent);
            }
        }
    };

    return (
        <>
            <JoditEditor
                ref={editorRef}
                value={secondContent}
                config={config}
                className="jodit-editor-content"
                tabIndex={1}
                onBlur={handleEditorChange}
            />
        </>
    );
};

export default QuillSecond;
